import i18n from "@/i18n";
import { financialNameById } from "@/enums/financials/financialNameById";

const rgpdPT = (finId) => {
    return [
        {

            "label": i18n.tc('pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.ptRgpd1', financialNameById[finId], {
                financial: financialNameById[finId],
            }),
            "type": "neo-toggle",
            "key": "GDPRSendInfoProducts",
            "saveKey": "gdprSendInfoProducts",
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "errorToast": "form.error.rgpdsFieldNotAcceptedSofinco1",
            "value": "",
            "editable": true,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "proposalType": [
                "PT"
            ]
        },
        {
            "label": i18n.tc('pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.ptRgpd2', financialNameById[finId], {
                financial: financialNameById[finId],
            }),
            "type": "neo-toggle",
            "key": "GDPRAccessGovernmentData",
            "saveKey": "gdprAccessGovernmentData",
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "value": 2,
            "errorToast": "form.error.rgpdsFieldNotAcceptedSofinco2",
            "editable": true,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "proposalType": [
                "PT"
            ]
        },
        {
            "label": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.ptRgpd3",
            "type": "neo-toggle",
            "key": "refusedDeliveryDocumentation",
            "saveKey": "refusedDeliveryDocumentation",
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "value": 2,
            "errorToast": "form.error.rgpdsFieldNotAcceptedSofinco3",
            "editable": true,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "proposalType": [
                "PT"
            ]
        }
    ];
}

const rgpdLabelsByFinancial = {
    // SOFINCO
    13: [
        {
            "label": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.sofincoRgpd1",
            "type": "neo-toggle",
            "key": "commercialAndMarketingDataUsage",
            "saveKey": "commercialAndMarketingDataUsage",
            "firstRGPD": true,
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "errorToast": "form.error.rgpdsFieldNotAcceptedSofinco1",
            "value": "",
            "editable": true,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "proposalType": [
                "ES"
            ]
        },
        {
            "label": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.sofincoRgpd2",
            "type": "neo-toggle",
            "key": "contractManagementDataUsage",
            "saveKey": "contractManagementDataUsage",
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "value": 2,
            "errorToast": "form.error.rgpdsFieldNotAcceptedSofinco2",
            "editable": true,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "proposalType": [
                "ES"
            ]
        },
        {
            "label": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.sofincoRgpd3",
            "type": "neo-toggle",
            "key": "marketingCommunications",
            "saveKey": "marketingCommunications",
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "value": 2,
            "errorToast": "form.error.rgpdsFieldNotAcceptedSofinco3",
            "editable": true,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "proposalType": [
                "ES"
            ]
        },
        {
            "label": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.sofincoRgpd4",
            "type": "neo-toggle",
            "key": "thirdPartyDataTransfer",
            "saveKey": "thirdPartyDataTransfer",
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "value": 2,
            "errorToast": "form.error.rgpdsFieldNotAcceptedSofinco4",
            "editable": true,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "proposalType": [
                "ES"
            ]
        },
        {
            "label": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.sofincoRgpd5",
            "type": "neo-toggle",
            "key": "GDPRSendInfoProducts",
            "saveKey": "gdprSendInfoProducts",
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "value": 2,
            "errorToast": "form.error.rgpdsFieldNotAcceptedSofinco4",
            "editable": true,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "proposalType": [
                "ES"
            ]
        },
        {
            "label": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.sofincoRgpd6",
            "type": "neo-toggle",
            "key": "GDPRBankReader",
            "saveKey": "gdprBankReader",
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "value": 2,
            "errorToast": "form.error.rgpdsFieldNotAcceptedSofinco4",
            "editable": true,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "proposalType": [
                "ES"
            ]
        },
        {
            "label": "",
            "type": "text-label",
            "valueLabel": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.sofincoDisclaimer",
            "key": "disclaimer",
            "saveKey": "disclaimer",
            "editable": false,
            "required": false,
            "fieldShow": true,
            "flexdir": "row",
            "justifyBetween": "justify-between",
            "colspan": 12,
            "proposalType": [
                "ES"
            ]
        }
    ],
    // BBVA ES
    12: [
        {
            "label": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.bbvaEsRgpd1",
            "type": "neo-toggle",
            "key": "commercialAndMarketingDataUsage",
            "saveKey": "commercialAndMarketingDataUsage",
            "firstRGPD": true,
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "errorToast": "form.error.rgpdsFieldNotAcceptedBBVAES1",
            "value": "",
            "editable": true,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "proposalType": [
                "ES"
            ]
        },
        {
            "label": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.bbvaEsRgpd2",
            "type": "neo-toggle",
            "key": "marketingCommunications",
            "saveKey": "marketingCommunications",
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "value": 2,
            "errorToast": "form.error.rgpdsFieldNotAcceptedSofinco3",
            "editable": true,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "proposalType": [
                "ES"
            ]
        },
        {
            "label": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.bbvaEsRgpd3",
            "type": "neo-toggle",
            "key": "contractManagementDataUsage",
            "saveKey": "contractManagementDataUsage",
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "value": 2,
            "errorToast": "form.error.rgpdsFieldNotAcceptedSofinco1",
            "editable": true,
            "required": true,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "proposalType": [
                "ES"
            ]
        }
    ],
    // Caixabank
    15: [
        {
            "label": "",
            "type": "text-label",
            "valueLabel": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.caixabankDisclaimer",
            "key": "disclaimer",
            "saveKey": "disclaimer",
            "editable": false,
            "required": false,
            "fieldShow": true,
            "flexdir": "row",
            "justifyBetween": "justify-between",
            "colspan": 12,
            "proposalType": [
                "ES"
            ]
        },
        {
            "label": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.caixabankRgpd6",
            "type": "neo-toggle",
            "key": "GDPRSendInfoProducts",
            "saveKey": "gdprSendInfoProducts",
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "value": 2,
            "errorToast": "form.error.rgpdsFieldNotAcceptedCaixabank3",
            "editable": true,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "proposalType": [
                "ES"
            ]
        },
        {
            "label": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.caixabankRgpd7",
            "type": "neo-toggle",
            "key": "clientSatisfactionDataUsage",
            "saveKey": "clientSatisfactionDataUsage",
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "value": 2,
            "errorToast": "form.error.rgpdsFieldNotAcceptedCaixabank4",
            "editable": true,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "proposalType": [
                "ES"
            ]
        },
        {
            "label": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.caixabankRgpd5",
            "type": "neo-toggle",
            "key": "commercialAndMarketingDataUsage",
            "saveKey": "commercialAndMarketingDataUsage",
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "value": 2,
            "errorToast": "form.error.rgpdsFieldNotAcceptedCaixabank2",
            "editable": true,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "proposalType": [
                "ES"
            ]
        },
        {
            "label": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.caixabankRgpd2",
            "type": "neo-toggle",
            "key": "contractManagementDataUsage",
            "saveKey": "contractManagementDataUsage",
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "value": 2,
            "errorToast": "form.error.rgpdsFieldNotAcceptedCaixabank1",
            "editable": true,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "proposalType": [
                "ES"
            ]
        },
        {
            "label": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.caixabankRgpd3",
            "type": "neo-toggle",
            "key": "marketingCommunications",
            "saveKey": "marketingCommunications",
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "value": 2,
            "errorToast": "form.error.rgpdsFieldNotAcceptedSofinco3",
            "editable": true,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "proposalType": [
                "ES"
            ]
        },
        {
            "label": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.caixabankRgpd4",
            "type": "neo-toggle",
            "key": "thirdPartyDataTransfer",
            "saveKey": "thirdPartyDataTransfer",
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "value": 2,
            "errorToast": "form.error.rgpdsFieldNotAcceptedSofinco4",
            "editable": true,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "proposalType": [
                "ES"
            ]
        },
        {
            "label": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.caixabankRgpd1",
            "type": "neo-toggle",
            "key": "GDPRBankReader",
            "saveKey": "gdprBankReader",
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "value": 2,
            "errorToast": "form.error.rgpdsFieldNotAcceptedSofinco4",
            "editable": true,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "proposalType": [
                "ES"
            ]
        }
    ],
    // Credibom
    9: [
        {
            "label": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.credibomRgpd1",
            "type": "neo-toggle",
            "key": "commercialAndMarketingDataUsage",
            "saveKey": "commercialAndMarketingDataUsage",
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "errorToast": "form.error.rgpdsFieldNotAcceptedSofinco1",
            "value": "",
            "editable": true,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "proposalType": [
                "PT"
            ]
        },
        {
            "label": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.credibomRgpd2",
            "type": "neo-toggle",
            "key": "contractManagementDataUsage",
            "saveKey": "contractManagementDataUsage",
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "value": 2,
            "errorToast": "form.error.rgpdsFieldNotAcceptedSofinco2",
            "editable": true,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "proposalType": [
                "PT"
            ]
        },
        {
            "label": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.credibomRgpd3",
            "type": "neo-toggle",
            "key": "thirdPartyDataTransfer",
            "saveKey": "thirdPartyDataTransfer",
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "value": 2,
            "errorToast": "form.error.rgpdsFieldNotAcceptedSofinco3",
            "editable": true,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "proposalType": [
                "PT"
            ]
        },
        {
            "label": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.credibomRgpd4",
            "type": "neo-toggle",
            "key": "clientSatisfactionDataUsage",
            "saveKey": "clientSatisfactionDataUsage",
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "value": 2,
            "errorToast": "form.error.rgpdsFieldNotAcceptedSofinco4",
            "editable": true,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "proposalType": [
                "PT"
            ]
        },
        {
            "label": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.credibomRgpd5",
            "type": "neo-toggle",
            "key": "marketingCommunications",
            "saveKey": "marketingCommunications",
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "value": 2,
            "editable": true,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "proposalType": [
                "PT"
            ]
        }
    ],
    // Cetelem Spain
    16: [
        {
            "label": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.cetelemSpainRgpd5",
            "type": "text-label",
            "key": "GDPRPersonalDataProtection",
            "saveKey": "gdprPersonalDataProtection",
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "value": 1,
            "errorToast": "form.error.rgpdsFieldNotAcceptedCeletenSpain5",
            "editable": false,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "withModal": true,
            "modalText": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.cetelemSpainRgpd5Modal",
            "proposalType": [
                "ES"
            ]
        },
        {
            "label": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.cetelemSpainRgpd1",
            "type": "neo-toggle",
            "key": "contractManagementDataUsage",
            "saveKey": "contractManagementDataUsage",
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "value": 2,
            "errorToast": "form.error.rgpdsFieldNotAcceptedSofinco2",
            "editable": true,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "withModal": true,
            "modalText": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.cetelemSpainRgpd1Modal",
            "proposalType": [
                "ES"
            ]
        },
        {
            "label": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.cetelemSpainRgpd3",
            "type": "neo-toggle",
            "key": "marketingCommunications",
            "saveKey": "marketingCommunications",
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "value": 2,
            "errorToast": "form.error.rgpdsFieldNotAcceptedSofinco3",
            "editable": true,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "withModal": true,
            "modalText": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.cetelemSpainRgpd3Modal",
            "proposalType": [
                "ES"
            ]
        },
        {
            "label": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.cetelemSpainRgpd4",
            "type": "neo-toggle",
            "key": "thirdPartyDataTransfer",
            "saveKey": "thirdPartyDataTransfer",
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "value": 2,
            "errorToast": "form.error.rgpdsFieldNotAcceptedSofinco4",
            "editable": true,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "withModal": true,
            "modalText": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.cetelemSpainRgpd4Modal",
            "proposalType": [
                "ES"
            ]
        }
    ],
    // BBVA PT
    2: [
        {
            "label": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.bbvaPTRgpd1",
            "type": "neo-toggle",
            "key": "commercialAndMarketingDataUsage",
            "saveKey": "commercialAndMarketingDataUsage",
            "firstRGPD": true,
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "errorToast": "form.error.rgpdsFieldNotAcceptedBBVAPT1",
            "value": "",
            "editable": true,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "proposalType": [
                "PT"
            ]
        },
        {
            "label": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.bbvaPTRgpd2",
            "type": "neo-toggle",
            "key": "marketingCommunications",
            "saveKey": "marketingCommunications",
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "value": 2,
            "errorToast": "form.error.rgpdsFieldNotAcceptedBBVAPT2",
            "editable": true,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "proposalType": [
                "PT"
            ]
        },
        {
            "label": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.bbvaPTRgpd3",
            "type": "neo-toggle",
            "key": "contractManagementDataUsage",
            "saveKey": "contractManagementDataUsage",
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "value": 2,
            "errorToast": "form.error.rgpdsFieldNotAcceptedBBVAPT3",
            "editable": true,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "proposalType": [
                "PT"
            ]
        }
    ],
    // // Santander Consumer
    // 4: rgpdPT(4),
    // BPI
    6: rgpdPT(6),
    // // CGD
    // 7: rgpdPT(7),
    // // Cetelem
    // 8: rgpdPT(8)
    // Cofidis PT
    19: [
        {
            "label": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.cofidisPTRgpd1",
            "type": "neo-toggle",
            "key": "commercialAndMarketingDataUsage",
            "saveKey": "commercialAndMarketingDataUsage",
            "firstRGPD": true,
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "errorToast": "form.error.rgpdsFieldNotAcceptedCofidisPT1",
            "value": "",
            "editable": true,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "proposalType": [
                "PT"
            ]
        },
        {
            "label": "",
            "type": "text-label",
            "valueLabel": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.cofidisPTDisclaimer",
            "key": "disclaimer",
            "saveKey": "disclaimer",
            "editable": false,
            "required": false,
            "fieldShow": true,
            "flexdir": "row",
            "justifyBetween": "justify-start",
            "colspan": 12,
            "proposalType": [
                "PT"
            ]
        },
        {
            "label": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.cofidisPTRgpd2",
            "type": "neo-toggle",
            "key": "marketingCommunications",
            "saveKey": "marketingCommunications",
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "value": 2,
            "errorToast": "form.error.rgpdsFieldNotAcceptedCofidisPT1",
            "editable": true,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "proposalType": [
                "PT"
            ]
        },
        {
            "label": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.cofidisPTRgpd3",
            "type": "neo-toggle",
            "key": "contractManagementDataUsage",
            "saveKey": "contractManagementDataUsage",
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "value": 2,
            "errorToast": "form.error.rgpdsFieldNotAcceptedCofidisPT1",
            "editable": true,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "proposalType": [
                "PT"
            ]
        },
        {
            "label": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.cofidisPTRgpd4",
            "type": "neo-toggle",
            "key": "thirdPartyDataTransfer",
            "saveKey": "thirdPartyDataTransfer",
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "value": 2,
            "errorToast": "form.error.rgpdsFieldNotAcceptedCofidisPT1",
            "editable": true,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "proposalType": [
                "PT"
            ]
        },
        {
            "label": "pages.ProposalsPage.proposalsForm.participantsData.rgpd.label.cofidisPTRgpd5",
            "type": "neo-toggle",
            "key": "clientSatisfactionDataUsage",
            "saveKey": "clientSatisfactionDataUsage",
            "leftLabel": "pages.ProposalsPage.proposalsForm.toggleButton.y",
            "rightLabel": "pages.ProposalsPage.proposalsForm.toggleButton.n",
            "uppercaseLabel": false,
            "value": 2,
            "errorToast": "form.error.rgpdsFieldNotAcceptedCofidisPT1",
            "editable": true,
            "required": false,
            "flexdir": "row",
            "colspan": 12,
            "gap": 16,
            "justifyBetween": "justify-between",
            "fieldShow": true,
            "proposalType": [
                "PT"
            ]
        }
    ],
};

export { rgpdLabelsByFinancial }

